const skills = [
	{ value: "Active Listening", label: "Active Listening" },
	{ value: "Public Speaking", label: "Public Speaking" },
	{ value: "Critical Thinking", label: "Critical Thinking" },
	{ value: "Reading Comprehension", label: "Reading Comprehension" },
	{ value: "Monitoring", label: "Monitoring" },
	{ value: "Social Perceptiveness", label: "Social Perceptiveness" },
	{ value: "Coordination", label: "Coordination" },
	{ value: "Time Management", label: "Time Management" },
	{ value: "Judgement and Decision Making", label: "Judgement and Decision Making" },
	{ value: "Active Learning", label: "Active Learning" },
	{ value: "Service Orientation", label: "Service Orientation" },
	{ value: "Complex Problem Solving", label: "Complex Problem Solving" },
	{ value: "Writing", label: "Writing" },
	{ value: "Instructing", label: "Instructing" },
	{ value: "Learning Strategies", label: "Learning Strategies" },
	{ value: "Negotiation", label: "Negotiation" },
	{ value: "Management of Personnel Resources", label: "Management of Personnel Resources" },
	{ value: "Mathematics", label: "Mathematics" },
	{ value: "Systems Analysis", label: "Systems Analysis" },
	{ value: "Systems Evaluation", label: "Systems Evaluation" },
	{ value: "Operation Monitoring", label: "Operation Monitoring" },
	{ value: "Quality Control Analysis", label: "Quality Control Analysis" },
	{ value: "Operations Analysis", label: "Operations Analysis" },
	{ value: "Operation and Control", label: "Operation and Control" },
	{ value: "Management of Material Resources", label: "Management of Material Resources" },
	{ value: "Management of Financial Resources", label: "Management of Financial Resources" },
	{ value: "Technology Design", label: "Technology Design" },
	{ value: "Programming", label: "Programming" },
	{ value: "Troubleshooting", label: "Troubleshooting" },
	{ value: "Science", label: "Science" },
	{ value: "Equipment Selection", label: "Equipment Selection" },
	{ value: "Equipment Maintenance", label: "Equipment Maintenance" },
	{ value: "Repairing", label: "Repairing" },
	{ value: "Installation", label: "Installation" },
	{ value: "Persuasion", label: "Persuasion" },
	{ value: "Customer Focus", label: "Customer Focus" },
	{ value: "Creativity", label: "Creativity" },
	{ value: "Adaptability", label: "Adaptability" },
	{ value: "Motivation", label: "Motivation" },
];

export default skills;



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/Skills.js